export const TopNavDesktopHeight = '80px';
export const TopNavMobileHeight = '64px';
